import { type ReactNode } from "react";

export const Root = ({ children }: { children?: ReactNode }): ReactNode =>
  children ?? null;
